import * as React from 'react';

import { StyleSheet, css } from '@coursera/coursera-ui';

import { ProficiencyLevels } from 'bundles/enterprise-admin-skills/svg';
import { SkillLevels, getSkillRangeLabels } from 'bundles/enterprise-admin-skills/utils/skillTargets';

const styles = StyleSheet.create({
  container: {
    width: 345,
  },
  levelLabel: {
    color: 'var(--cds-color-grey-400)',
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  legendContainer: {
    marginTop: 20,
  },
  legendText: {
    fontSize: 14,
    lineHeight: '24px',
    backgroundColor: 'var(--cds-color-neutral-background-primary-weak)',
    padding: '0 12px',
    marginBottom: 0,
  },
  legendLevel: {
    color: 'var(--cds-color-grey-700)',
    width: '100%',
  },
  legendRow: {
    marginTop: 4,
  },
  legendRange: {
    fontWeight: 'bold',
    textAlign: 'right',
    marginRight: 4,
    minWidth: 84,
    maxWidth: 84,
  },
});

const LegendRow = ({ skillLevel, color }: { skillLevel: SkillLevels; color: string }) => {
  const { range, level } = getSkillRangeLabels()[skillLevel];
  return (
    <div {...css(styles.legendRow, 'horizontal-box')}>
      <p {...css(styles.legendText, styles.legendRange)} style={{ color }}>
        {range}
      </p>
      <p {...css(styles.legendText, styles.legendLevel)}>{level}</p>
    </div>
  );
};

const ProficiencyLevelsInfoGraph = (_props: {}) => (
  <div {...css(styles.container, 'vertical-box')}>
    <ProficiencyLevels />
    <div {...css(styles.legendContainer, 'vertical-box')}>
      <LegendRow skillLevel={SkillLevels.conversant} color="var(--cds-color-grey-200)" />
      <LegendRow skillLevel={SkillLevels.beginner} color="var(--cds-color-grey-400)" />
      <LegendRow skillLevel={SkillLevels.intermediate} color="var(--cds-color-grey-800)" />
      <LegendRow skillLevel={SkillLevels.advanced} color="var(--cds-color-neutral-primary)" />
    </div>
  </div>
);

export default ProficiencyLevelsInfoGraph;
